// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"c9b46e06","113":"d0426a7b","200":"94dd6076","210":"021b4a2f","473":"e91a5f13","523":"47eb8606","706":"e83be57c","708":"afd181aa","770":"c5e8e1e5","845":"fda2be14","855":"13defc55"}[chunkId] + ".chunk.js";
};